import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

type Props = {
    id: string;
    label: string;
    value: number | null;
    min: number;
    disabled?: boolean;
    onSave: (value: number) => void;
};

export const SettingsNumberInput = ({ id, label, value: savedValue, min, disabled = false, onSave }: Props) => {
    const savedText = savedValue?.toString() ?? '';
    const [text, setText] = useState(savedText);

    useEffect(() => {
        setText(savedText);
    }, [savedText]);

    const handleBlur = () => {
        const parsed = Number(text);
        const isValid = text.trim() !== '' && Number.isInteger(parsed) && parsed >= min;
        if (!isValid) {
            setText(savedText);
            return;
        }
        if (parsed !== savedValue) {
            onSave(parsed);
        }
    };

    return (
        <TextField
            id={id}
            label={label}
            type="number"
            value={text}
            disabled={disabled}
            fullWidth
            size="small"
            slotProps={{ inputLabel: { shrink: true }, htmlInput: { min, step: 1 } }}
            onChange={(event) => setText(event.target.value)}
            onBlur={handleBlur}
        />
    );
};
